(function () {
    'use strict';
  
    angular
      .module('localization')
      .config(config);
  
    function config($translateProvider) {
  
      var data = {
        'common': {
            'addikoBankLocation': 'Lokacija Addiko Bank centrale',
            'openInGoogleMap': 'Otvori u Google Maps'
        }
      }

      $translateProvider.translations('sr', data);
    }

}());